// src/hooks/useFrutoGraduatesCount.js
// Cuenta cuántos discípulos completaron Las Ramas de FRUTO y todavía no son
// mentor/admin — la misma señal que ya se muestra en /admin/, pero disponible fuera
// de ese panel para encender el punto dorado del ícono de admin en Layout.js. Solo se
// debe invocar cuando profile?.role === "admin" (a diferencia de usePromotionAck, esto
// sí agrega una consulta a Firestore en cada carga de página — ver
// project-log/initiatives/paneles-discipulo-lider.md, Fase extra 3, Fase E).

import { useState, useEffect } from "react";
import { getFrutoGraduatesPendingPromotion, getAllUsers } from "../services/admin-service";

export function useFrutoGraduatesCount(enabled) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    Promise.all([getFrutoGraduatesPendingPromotion(), getAllUsers()]).then(([graduates, users]) => {
      const promotedUids = new Set(
        users.filter((u) => u.role === "mentor" || u.role === "admin").map((u) => u.uid)
      );
      const pending = new Set(graduates.map((g) => g.userId).filter((uid) => !promotedUids.has(uid)));
      setCount(pending.size);
    });
  }, [enabled]);

  return count;
}
